import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { PractitionerService } from 'app/core/http/services/practitioner.service';
import { PractitionerroleService } from 'app/core/http/services/practitionerrole.service';

@Component({
  selector: 'practitioner-view',
  templateUrl: './practitioner-view.component.html',
  styleUrls: ['./practitioner-view.component.scss'],
})
export class PractitionerViewComponent implements OnInit, OnChanges {
  @Input() practitioner: any;
  public practitionerData: any = null;
  public practitionerRoleData: any = null;
  public loading = true;
  public readonly defaultPractitionerPhoto = '/assets/fotos/practitioner_default_photo.png';

  constructor(private practitionerService: PractitionerService, private practitionerroleService: PractitionerroleService) {}

  ngOnInit() {
    this.loadData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['practitioner'] && changes['practitioner'].currentValue) {
      this.loadData();
    }
  }

  async loadData() {
    if (this.practitioner?.practitioner_id) {
      this.loading = true;
      try {
        const [practitioner, practitionerRole] = await Promise.all([
          this.getPractitioner(this.practitioner.practitioner_id),
          this.getPractitionerRole(this.practitioner.practitioner_id),
        ]);
        this.practitionerData = practitioner;
        this.practitionerRoleData = practitionerRole;
      } catch (error) {
        console.error('Erro ao carregar os dados:', error);
      } finally {
        this.loading = false;
      }
    }
  }

  getPractitioner(practitionerId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.practitionerService.showNew(practitionerId).subscribe({
        next: (data) => resolve(data),
        error: (err) => reject(err),
      });
    });
  }

  getPractitionerRole(practitionerId: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.practitionerroleService.findPractitionerByPractitionerroleId(practitionerId).subscribe({
        next: (data) => resolve(data[0] || null),
        error: (err) => reject(err),
      });
    });
  }
}
